module.exports = __webpack_public_path__ + "img/door-opened-icon.33376377.svg";